import type { Status } from "@gui-creator/gemeinsam";

export const STATUS_ANZEIGE: Record<Status, { text: string; marke: "hohl" | "halb" | "voll" | "punkt" | "haken"; farbe: string }> = {
  idee: { text: "Idee", marke: "hohl", farbe: "var(--status-idee)" },
  in_arbeit: { text: "In Arbeit", marke: "halb", farbe: "var(--status-arbeit)" },
  bereit: { text: "Bereit", marke: "voll", farbe: "var(--status-bereit)" },
  freigegeben: { text: "Freigegeben", marke: "punkt", farbe: "var(--status-freigegeben)" },
  im_spiel: { text: "Im Spiel", marke: "haken", farbe: "var(--status-spiel)" },
};

export function StatusMarke({ status, groesse = 10 }: { status: Status; groesse?: number }) {
  const { marke, farbe, text } = STATUS_ANZEIGE[status];
  return (
    <svg width={groesse} height={groesse} viewBox="0 0 10 10" role="img" aria-label={text} style={{ flex: "none", color: farbe }}>
      <title>{text}</title>
      {marke === "hohl" && <circle cx="5" cy="5" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />}
      {marke === "halb" && (
        <>
          <circle cx="5" cy="5" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M5 1a4 4 0 0 1 0 8z" fill="currentColor" />
        </>
      )}
      {marke === "voll" && <circle cx="5" cy="5" r="4.5" fill="currentColor" />}
      {marke === "punkt" && (
        <>
          <circle cx="5" cy="5" r="4.5" fill="currentColor" />
          <circle cx="5" cy="5" r="1.6" style={{ fill: "var(--status-kern)" }} />
        </>
      )}
      {marke === "haken" && (
        <>
          <circle cx="5" cy="5" r="4.5" fill="currentColor" />
          <path d="M3 5.1l1.4 1.4L7.1 3.8" fill="none" style={{ stroke: "var(--status-kern)" }} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </>
      )}
    </svg>
  );
}
